import {
  UseMutationOptions,
  UseQueryOptions,
  useMutation,
  useQuery,
} from "@tanstack/react-query"
import { IInvoice } from "./type"
import api from "services/api"

export function useInvoices(
  memberId: string,
  showTrash: boolean,
  config?: UseQueryOptions<IInvoice[]>
) {
  const params = {
    filter: {
      status: {
        operator: "in",
        values: showTrash
          ? ["recoverable", "canceled", "paid"]
          : ["proforma", "unpaid"],
      },
    },
  }
  return useQuery<IInvoice[]>(
    ["operation", "administration", "members", memberId, "invoices", params],
    {
      ...config,
    }
  )
}

export function useInvoice(
  memberId: string,
  invoiceId: string,
  config?: UseQueryOptions<IInvoice>
) {
  return useQuery<IInvoice>(
    ["operation", "administration", "members", memberId, "invoices", invoiceId],
    {
      ...config,
    }
  )
}

export function usePaymentMethods(
  config?: UseQueryOptions<{ name: string }[]>
) {
  return useQuery<{ name: string }[]>(["payment-methods"], config)
}

export function usePayInvoice(
  invoiceId: string,
  config?: UseMutationOptions<unknown, unknown, { source_id: string }, unknown>
) {
  return useMutation<unknown, unknown, { source_id: string }, unknown>(
    (data) => api.post(`operation/sales/invoices/${invoiceId}/payment`, data),
    config
  )
}
